import request from '@/utils/request'

// 查询商品列表
export function listTable(data) {
  return request({
    url: '/sysGoods/list',
    method: 'post',
    data,
  })
}

// 新增商品
export function addTable(data) {
  return request({
    url: '/sysGoods/insert',
    method: 'post',
    data: data,
  })
}

// 修改商品
export function updateTable(data) {
  return request({
    url: '/sysGoods/update',
    method: 'post',
    data: data,
  })
}

// 删除商品
export function delTable(id) {
  return request({
    url: '/sysGoods/delete?id=' + id,
    method: 'get',
  })
}
